var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXprt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2h17.026v3.595H7.5V2zm16.135 16.416c.594-1.082.89-2.27.89-3.564 0-1.4-.307-2.641-.922-3.724-.616-1.082-1.538-1.93-2.769-2.545-1.23-.616-2.737-.923-4.519-.923H7.5V30h5.442v-8.02h3.373c1.825 0 3.352-.328 4.583-.986 1.23-.658 2.142-1.517 2.737-2.578zm-5.41-1.496c-.51.488-1.284.732-2.324.732h-2.958v-5.6h2.96c1.04 0 1.813.243 2.323.731.509.488.763 1.178.763 2.069 0 .89-.254 1.58-.763 2.068z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXprt);
export default __webpack_public_path__ + "static/media/XPRT.98519918f51ab6bd9e21084dba394100.svg";
export { ForwardRef as ReactComponent };